<template>
  <v-app id="inspire">
    <LayoutStructure v-if="this.$store.getters.isAuthenticated && this.$store.getters.nivel == 1">
      <router-view></router-view>
    </LayoutStructure>
    
    <LayoutStructureAdm v-if="this.$store.getters.isAuthenticated && this.$store.getters.nivel == 5">
      <router-view></router-view>
    </LayoutStructureAdm>

    <LayoutStructureUser v-if="this.$store.getters.isAuthenticated && this.$store.getters.nivel == 2">
      <router-view></router-view>
    </LayoutStructureUser>

    <LayoutStructureOdonto v-if="this.$store.getters.isAuthenticated && this.$store.getters.nivel == 3">
      <router-view></router-view>
    </LayoutStructureOdonto>

    <LayoutStructureUnidade v-if="this.$store.getters.isAuthenticated && this.$store.getters.nivel == 6">
      <router-view></router-view>
    </LayoutStructureUnidade>

    <router-view v-if="!this.$store.getters.isAuthenticated"></router-view>

    <Footer v-if="this.$store.getters.isAuthenticated"></Footer>
  </v-app>
</template>

<script>
import LayoutStructure from "./components/LayoutStructure.vue";
import LayoutStructureUser from "./components/LayoutStructureUser.vue";
import LayoutStructureOdonto from "./components/LayoutStructureOdonto.vue";
import LayoutStructureAdm from "./components/LayoutStructureAdm.vue";
import LayoutStructureUnidade from "./components/LayoutStructureFC";
import Footer from "./components/Footer.vue";
import { mapState } from "vuex";

export default {
  name: "App",
  components: {
    LayoutStructure,
    LayoutStructureUser,
    LayoutStructureOdonto,
    LayoutStructureAdm,
    LayoutStructureUnidade,
    Footer,
  },
  computed: {
    ...mapState({
      currentUser: "currentUser",
    }),
  },

  data() {
    return {
      nivel: "user",
    };
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      console.log(process.env.VUE_APP_SERVER_URL);
    },
  },
};
</script>

<style>
html,
body {
  font-size: 1em;
}
</style>
